import axios from 'axios'
import qs from 'qs'
import {
  newAxios
} from '.'
const userId = true
export const Req_GetPhoneCode = data => {
  return newAxios({
    url: `/stu/sms/code/login`,
    data
  })()
}

export const Req_Login = data => {
  return newAxios({
    url: `/stu/user/login/password`,
    data
  })()
}

export const Req_ChangePwd = data => {
  return newAxios({
    url: `/stu/user/modify/password`,
    data
  })()
}

export const Req_DataMerge = data => {
  return newAxios({
    url: `/stu/user/merge`,
    data
  })()

}


// WEBPACK FOOTER //
// ./src/ajax/account.js